/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import {
  ApiResponse,
  DocumentUrlData,
  ImageUrlData,
  RemovePayload,
} from "models";
import brandApi from "api/brand";
import { BrandPayload, BrandSubmitForm, UpdateBrandStatus } from "models/brand";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import brandLocationApi from "api/brandLocationApi";
// import { brandLocationActions } from "./brandLocationSlice";
import { BrandList, BrandLocations } from "models/brandLocation";
import { documentActions } from "./documentSlice";
import documentApi from "api/document";
import { DocumentForm, StoreList } from "models/document";
// import BrandLocationAction from "../components/action";

function* getDocument(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      documentApi.getDocumentList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(documentActions.getDocumentSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    yield put(documentActions.getDocumentFailed(errorData));
  }
}

function* getDocumentById(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      documentApi.getDocumentById,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(documentActions.getDocumentByIdSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    yield put(documentActions.getDocumentByIdFailed(errorData));
  }
}

function* addDocument(action: PayloadAction<DocumentForm>) {
  try {
    const response: ApiResponse = yield call(
      documentApi.addDocument,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(documentActions.addDocumentSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(documentActions.addDocumentFailed(errorData));
  }
}

function* updateDocument(action: PayloadAction<DocumentForm>) {
  try {
    const response: ApiResponse = yield call(
      documentApi.updateDocument,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(documentActions.updateDocumentSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(documentActions.updateDocumentFailed(errorData));
  }
}

function* deleteDocument(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      documentApi.deleteDocument,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(documentActions.deleteDocumentSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(documentActions.deleteDocumentFailed(errorData));
  }
}

function* getBrandList(action: PayloadAction<BrandList>) {
  try {
    const response: ApiResponse = yield call(
      documentApi.brandListApi,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(documentActions.getBrandListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    yield put(documentActions.getBrandListFailed(errorData));
  }
}

function* getStoreListData(action: PayloadAction<StoreList>) {
  try {
    const response: ApiResponse = yield call(
      documentApi.storeListApi,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(documentActions.getStoreListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    yield put(documentActions.getStoreListFailed(errorData));
  }
}

function* getDocumentUrl(action: PayloadAction<DocumentUrlData>) {
  try {
    const response: ApiResponse = yield call(
      documentApi.getDocumentUrl,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(documentActions.getDocumentUrlSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(documentActions.getDocumentUrlFailed(errorData));
  }
}

function* getCustomerListData(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(documentApi.getCustomerList);
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(documentActions.getCustomerListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    yield put(documentActions.getCustomerListFailed(errorData));
  }
}

export default function* documentSaga() {
  yield takeLatest(documentActions.getDocument.type, getDocument);
  yield takeLatest(documentActions.getDocumentById.type, getDocumentById);
  yield takeLatest(documentActions.addDocument.type, addDocument);
  yield takeLatest(documentActions.updateDocument.type, updateDocument);
  yield takeLatest(documentActions.deleteDocument.type, deleteDocument);
  yield takeLatest(documentActions.getBrandList.type, getBrandList);
  yield takeLatest(documentActions.getStoreList.type, getStoreListData);
  yield takeLatest(documentActions.getDocumentUrl.type, getDocumentUrl);
  yield takeLatest(documentActions.getCustomerList.type, getCustomerListData);
}
